import { qs } from "@/utils/dom";

interface ContactFormResponse {
  message?: string;
}

export function initContactForm(): void {
  const form = qs<HTMLFormElement>("[data-contact-form]");
  if (!form) return;

  const submitButton = qs<HTMLButtonElement>("button[type=submit]", form);
  const statusEl = qs<HTMLElement>("[data-form-status]", form);

  form.addEventListener("submit", async (event) => {
    event.preventDefault();

    if (submitButton) submitButton.disabled = true;
    if (statusEl) statusEl.textContent = "Sending...";

    try {
      const response = await fetch(form.action, {
        method: form.method || "POST",
        body: new FormData(form),
        headers: { Accept: "application/json" },
      });

      const data: ContactFormResponse | null = await response.json().catch(() => null);

      if (!response.ok) {
        throw new Error(data?.message ?? `Request failed: ${response.status}`);
      }

      if (statusEl) statusEl.textContent = data?.message ?? "Thanks! We'll be in touch soon.";
      form.reset();
    } catch (error) {
      if (statusEl) {
        statusEl.textContent =
          error instanceof Error ? error.message : "Something went wrong. Please call us or try again.";
      }
    } finally {
      if (submitButton) submitButton.disabled = false;
    }
  });
}
